module.exports = __webpack_public_path__ + "media/terroir-explorable.e1a9794a.mp4";